var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      staticClass: "list-group-item ms-3",
      class: { active: _vm.isActive },
      on: { click: _vm.chooseExamRevision },
    },
    [
      _c("p", { staticClass: "fw-bold" }, [
        _vm._v(_vm._s(_vm.dateFormat(_vm.examRevision.createdAt))),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "fw-normal" }, [
        _vm._v(_vm._s(_vm.examRevision.user.name)),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }